import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { StatusPEI } from 'src/app/modules/institutional-resume/pages/educational-project/educational-project.type';
import { PeiService } from 'src/app/modules/institutional-resume/pages/educational-project/services/pei.service';
import { InfoModalComponent } from 'src/app/modules/shared/components/info-modal/info-modal.component';
import { showAlertDimeter } from 'src/app/utils/alert';

@Component({
	selector: 'app-send-pei',
	templateUrl: './send-pei.component.html',
	styleUrls: ['./send-pei.component.css'],
})
export class SendPeiComponent implements OnDestroy {
	private _unsubscribeAll: Subject<any> = new Subject<any>();
	@Input() status!: StatusPEI;
	@Output() sendStatus: EventEmitter<StatusPEI> = new EventEmitter<StatusPEI>();
	canSend: boolean = false;

	constructor(public dialog: MatDialog, private peiService: PeiService) {}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	onSubmitReview() {
		if (this.status.ok) {
			const confirmedRef = this.dialog.open(InfoModalComponent, {
				width: '90%',
				maxWidth: '350px',

				data: {
					isCancellable: true,
					message: '¿Está seguro que desea enviar la información?',
					subTitle:
						'Recuerde que al enviar información para revisión deberá esperar la respuesta por parte de la Secretaría de Educación Departamental del Valle del Cauca para aprobación o en su defecto poder editarla nuevamente. ',
					type: 'warning',
					buttonText: 'Confirmar envío',
				},
			});
			confirmedRef
				.afterClosed()
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((result) => {
					if (result?.confirmed) {
						const processingRef = this.dialog.open(InfoModalComponent, {
							width: '90%',
							maxWidth: '350px',

							data: {
								isCancellable: false,
								title: 'Procesando solicitud',
								message: 'Por favor no cierre la plataforma',
								type: 'processing',
							},
						});
						this.peiService
							.sendRevision()
							.pipe(takeUntil(this._unsubscribeAll))
							.subscribe({
								next: (response) => {
									processingRef.close();
									this.dialog.open(InfoModalComponent, {
										width: '90%',
										maxWidth: '350px',

										data: {
											title: '¡Operación exitosa!',
										},
									});
									console.log('Revisión enviada correctamente:', response.message);
									this.peiService
										.getStatusPei()
										.pipe(takeUntil(this._unsubscribeAll))
										.subscribe({
											next: (data) => {
												this.status = data;
												this.sendStatus.emit(this.status);
											},
											error: () => {
												this.status = {
													total: 0,
													completed: 0,
													percentage: '0',
													ok: false,
													status: 'UNDER_CONSTRUCTION',
												};
											},
										});
								},
								error: (err) => {
									const errorMessage =
										err.error && err.error.message
											? err.error.message
											: 'Ocurrió un error inesperado';
									processingRef.close();
									this.dialog.open(InfoModalComponent, {
										width: '90%',
										maxWidth: '350px',

										data: {
											title: '¡ Hubo un error !',
											message: `Error al enviar la revisión. ${errorMessage}`,
											type: 'error',
										},
									});
								},
							});
					}
				});
		} else {
			showAlertDimeter(
				'No se puede continuar, faltan datos obligatorios por completar',
				10000,
				false,
				() => {},
				'error',
			);
		}
	}
}
